module.exports = __webpack_public_path__ + "static/img/AIGC设计-模特生成.413540d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/goods/CPK10009/AIGC设计-模特生成.png
// module id = r1Hc
// module chunks = 1